(ns manatee.components.notifications.db)

(def alert-path [:alert-banner])
(def announcements-path [:announcements])
(def announcement-list-path (conj announcements-path :list))
(def announcement-show?-path (conj announcements-path :show?))

(defn banner-path
  [banner-id]
  (conj alert-path banner-id))

(defn get-announcements
  [db]
  (get-in db announcement-list-path))

(defn set-announcements
  [db announcements]
  (assoc-in db announcement-list-path announcements))

(defn show-announcements [db yes?] (assoc-in db announcement-show?-path yes?))
(defn show-announcements? [db] (get-in db announcement-show?-path))

(defn get-alerts
  [db banner-id]
  (get-in db (banner-path banner-id) []))

(defn alert-exists?
  [db banner-id alert-id]
  (some #(= alert-id (:id %)) (get-alerts db banner-id)))

(defn add-alert
  [db banner-id alert-id alert]
  ;; Alerts are stored as a list to maintain order, with newest added to the front
  (cond-> db
    (not (alert-exists? db banner-id alert-id))
    (update-in (banner-path banner-id)
               (fn [alerts]
                 (if alerts
                   (conj alerts (assoc alert :id alert-id))
                   (conj [] (assoc alert :id alert-id)))))))

(defn clear-alert
  [db banner-id alert-id]
  (update-in db (banner-path banner-id) #(remove (comp #{alert-id} :id) %)))
